// other Provision Reducer
const otherProvisionDefaultState = {
    animalsCharged: '',
    administrativeProceduresCharged: '',
    file : {}
};

export default (state = otherProvisionDefaultState, action) => {
    switch (action.type) {
        case 'SET_OTHER_PROVISION':
            return {
                ...state,
                responsibleAnimal: action.data.responsibleAnimal,
                administrativeProceduresCharged: action.data.administrativeProceduresCharged,
                file : action.data.file
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/otherProvision.js